import { SignUpPage } from "./SignUpPage.js";

export default SignUpPage;
